import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import EmbeddedModal from 'components/modal/EmbeddedModal'
import ModalButton from 'components/modal/ModalButton'

const NoMatches = props => {
  return (
    <Div
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <EmbeddedModal
        actions={[
          <ModalButton
            key="crush"
            testId="crush"
            title="Start Crush"
            onClick={props.onActionClick}
          />
        ]}
      >
        You have no matches yet. Tap {'"'}Start Crush{'"'} below and like more
        people to get matched.
      </EmbeddedModal>
    </Div>
  )
}

NoMatches.propTypes = {
  onActionClick: PropTypes.func
}

NoMatches.defaultProps = {
  onActionClick: () => {}
}

export default NoMatches



// WEBPACK FOOTER //
// ./src/components/matches/NoMatches.js